import React from "react";
import { MarketingNav } from "../components/marketing/MarketingNav";
import { Outlet } from "react-router-dom";
import Footer from "../components/marketing/Footer";
import { Analytics } from "@vercel/analytics/react";

export function MarketingLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <MarketingNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <Analytics />
    </div>
  );
}